import { render, staticRenderFns } from "./NewToSelflane.vue?vue&type=template&id=5e4cbbea&lang=pug"
import script from "./NewToSelflane.vue?vue&type=script&lang=js"
export * from "./NewToSelflane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__lkjqg4lemhx3tcnq4xpodjyioi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports